// extracted by mini-css-extract-plugin
export default {"root":"_1g3WX","icon":"_2JwUf","tooltip":"_21RR1"};